import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bulknet_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const role = localStorage.getItem('bulknet_role');
      localStorage.removeItem('bulknet_token');
      localStorage.removeItem('bulknet_user');
      localStorage.removeItem('bulknet_role');
      const empRoles = ['super_admin','operations','billing','marketing','account_manager'];
      if (role && empRoles.includes(role)) {
        window.location.href = '/employee/login';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
